export default __webpack_public_path__ + "static/media/Interactive Map.d1d5b4f0.svg";